export const TOGGLE_NOTIFICATIONS_PANEL = "TOGGLE_NOTIFICATIONS_PANEL";
export const CLOSE_NOTIFICATIONS_PANEL = "CLOSE_NOTIFICATIONS_PANEL";

export const FETCH_NOTIFICATIONS_REQUEST = "FETCH_NOTIFICATIONS_REQUEST";
export const FETCH_NOTIFICATIONS_SUCCESS = "FETCH_NOTIFICATIONS_SUCCESS";
export const FETCH_NOTIFICATIONS_FAILED = "FETCH_NOTIFICATIONS_FAILED";

export const FETCH_UNREAD_COUNT_REQUEST = "FETCH_UNREAD_COUNT_REQUEST";
export const FETCH_UNREAD_COUNT_SUCCESS = "FETCH_UNREAD_COUNT_SUCCESS";

export const MARK_NOTIFICATION_SEEN_REQUEST = "MARK_NOTIFICATION_SEEN_REQUEST";
export const MARK_ALL_NOTIFICATIONS_SEEN_REQUEST =
  "MARK_ALL_NOTIFICATIONS_SEEN_REQUEST";
export const VIEW_NOTIFICATION_REQUEST = "VIEW_NOTIFICATION_REQUEST";

export const NEW_NOTIFICATION_RECEIVED = "NEW_NOTIFICATION_RECEIVED";

export const FETCH_ENABLED_NOTIFICATIONS_REQUEST =
  "FETCH_ENABLED_NOTIFICATIONS_REQUEST";
export const FETCH_ENABLED_NOTIFICATIONS_SUCCESS =
  "FETCH_ENABLED_NOTIFICATIONS_SUCCESS";
export const FETCH_ENABLED_NOTIFICATIONS_FAILED =
  "FETCH_ENABLED_NOTIFICATIONS_FAILED";

export const UPDATE_ENABLED_NOTIFICATIONS_REQUEST =
  "UPDATE_ENABLED_NOTIFICATIONS_REQUEST";
export const UPDATE_ENABLED_NOTIFICATIONS_SUCCESS =
  "UPDATE_ENABLED_NOTIFICATIONS_SUCCESS";
export const UPDATE_ENABLED_NOTIFICATIONS_FAILED =
  "UPDATE_ENABLED_NOTIFICATIONS_FAILED";
